import commonsApi from '@/api/commons'

// initial state
const state = {
  apiParams: '',
  tableItems: [],
  aggregates: [],
  csvItems: [],
  tableItemsTotal: 0,
  itemDetail: {},
  customListTitle: '',
  customListSubTitles: [],
  pdfTitle: '',
  pdfSubtitles: [],
  loading: true,
  customLmListActions: [],
  hash: ''
}

const mutations = {
  mutateTableItems (state, response) {
    if (response !== false) {
      state.apiParams = response.params
      state.tableItems = response.data.items
      state.hash = response.data.hash
      state.tableItemsTotal = parseInt(response.data.total)
      state.aggregates = response.data.aggregates
      state.customListTitle = response.data.customListTitle
      state.customListSubTitles = response.data.customListSubTitles
      state.pdfTitle = response.data.pdfTitle
      state.pdfSubtitles = response.data.pdfSubtitles
      if (response.data.customLmListActions) {
        state.customLmListActions = response.data.customLmListActions
      } else {
        state.customLmListActions = []
      }
    } else {
      state.apiParams = ''
      state.tableItems = []
      state.tableItemsTotal = 0
      state.aggregates = []
      state.customLmListActions = []
    }
  },
  mutateCsvItems (state, response) {
    state.csvItems = response.data.items
  },
  mutateLoading (state, loading) {
    state.loading = !!loading
  },
  resetStates (state) {
    // La idea con esta mutation es poder usarla para volver al
    // estado inicial aquellos valores que cambien antes de llamar a
    // una action
    // esto previene un bug sutil que tenia lumbre por el cual al navegar
    // entre diferentes listados por unos segudos se veía el título del listado
    // anterior
    state.tableItems = []
  },
  mutateItemDetail (state, response) {
    state.itemDetail = response
  }
}

const actions = {
  async getItems ({ commit }, response) {
    commit('mutateLoading', true)
    commit('resetStates')
    try {
      const items = await commonsApi.getItems(response)
      commit('mutateTableItems', items)
      commit('mutateLoading', false)
    } catch (error) {
      commit('mutateTableItems', false)
      commit('mutateLoading', false)
      throw error
    }
  },
  async getItemDetail ({ commit }, response) {
    commit('mutateLoading', true)
    try {
      const item = await commonsApi.getItemDetail(response)
      commit('mutateItemDetail', item)
      commit('mutateLoading', false)
    } catch (error) {
      commit('mutateLoading', false)
      throw error
    }
  },
  async updateItemDetail ({ commit, state }, item) {
    try {
      commit('mutateLoading', true)
      let response = await commonsApi.updateItemDetail(item.path, item.data)
      commit('mutateLoading', false)
      return response
    } catch (error) {
      commit('mutateLoading', false)
      throw error
    }
  },
  async deleteItem ({ commit, state }, item) {
    commit('mutateLoading', true)
    await commonsApi.deleteItem(item.path, item.data)
    commit('mutateLoading', false)
  },
  async getCsvItems ({ commit }, args) {
    args.format = 'csv'
    const item = await commonsApi.getItems(args)
    commit('mutateCsvItems', item)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
